export default {
    data () {
        return {
            overlayTimeoutId: null,
            secondOverlayTimeoutId: null
        }
    },
    methods: {
        showLoader () {
            this.overlayTimeoutId = setTimeout(() => {
                this.loader = this.$loading.show({ loader: 'dots' })
            }, 500)

            this.secondOverlayTimeoutId = setTimeout(() => {
                this.hideLoader()
                this.loader = this.$loading.show({ loader: 'spinner', opacity: 0.8, canCancel: true }, { before: <TotemLoaderMsg /> })
            }, 5000)
        },
        hideLoader () {
            clearTimeout(this.overlayTimeoutId)
            clearTimeout(this.secondOverlayTimeoutId)
            this.loader?.hide()
        },
    },
    beforeDestroy () {
        this.hideLoader()
    }
}
